import React from 'react';

export default function Row(props) {
  return <div className="row  mt-4">{props.children}</div>;
}
